import React from 'react'
const defaultValue:any=""
const FilterContext = React.createContext(defaultValue)
export default FilterContext